import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import {
  UpdatePrivateReceiveKeywordCommand,
  UseTypes,
} from '../../../../../core/api/models';
import { ReceiveKeywordDto } from '../../../../../core/api/models/receive-keyword-dto';
import { OrganizationsService } from '../../../../../core/api/services/organizations.service';
import { PrivateNumbersService } from '../../../../../core/api/services/private-numbers.service';
import { ReceiveKeywordsService } from '../../../../../core/api/services/receive-keywords.service';
import { BaseFormPageComponent } from '../../../../shared/base/components/base-form-page.component';
import { CreatePrivateReceiveKeywordCommand } from '.././../../../../core/api/models/create-private-receive-keyword-command';
import { FormPageConfig } from './../../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-private-receive-keywords-form',
    templateUrl: './private-receive-keywords-form.component.html',
    imports: [BaseFormModule]
})
export class PrivateReceiveKeywordsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  pageVocabs = 'pages.assignNumbers.privateReceiveKeywords.form.';
  formPageConfig: FormPageConfig<ReceiveKeywordDto> = {};

  model: CreatePrivateReceiveKeywordCommand = {};
  get UseTypes() {
    return UseTypes;
  }

  organizationTitle;

  //#endregion

  constructor(
    protected currentService: ReceiveKeywordsService,
    public organizationService: OrganizationsService,
    public privateNumberService: PrivateNumbersService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.changeFormValidations();
  }

  initForm() {
    this.form = new FormGroup({
      privateNumberId: new FormControl('', Validators.required),
      organizationId: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
      keyword: new FormControl('', Validators.required),
      useType: new FormControl('', Validators.required),
      //edit mode
      organizationName: new FormControl(''),
      privateNumber: new FormControl(''),
      expireDate: new FormControl('', Validators.required),
    });
  }

  changeFormValidations() {
    try {
      if (this.formPageConfig.isEditMode) {
        this.form.controls['organizationName'].disable();
        this.form.controls['privateNumber'].disable();
        this.form.controls['price'].disable();
        this.form.get('privateNumberId').clearValidators();
        this.form.get('price').clearValidators();
        this.form.get('organizationId').clearValidators();
        this.form.get('organizationId').updateValueAndValidity();
        this.form.get('privateNumberId').updateValueAndValidity();
        this.form.get('price').updateValueAndValidity();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  initModel(): void {
    try {
      if (this.formPageConfig.isEditMode)
        this.model = Object.assign({}, this.formPageConfig.editData);
      else {
        this.model.expireDate = DateTimeService.getAYearLater();
        this.formPageConfig.editData = {};
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region Api

  //Create
  baseCreateApi(model: CreatePrivateReceiveKeywordCommand) {
    this.unSubs();

    this.loading = true;
    this.currentService
      .receiveKeywordsCreatePrivateReceiveKeywordPost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdatePrivateReceiveKeywordCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .receiveKeywordsUpdatePrivateReceiveKeywordPut({
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
  checkCreateOrUpdate() {
    if (this.loading || !this.form.valid) return;

    if (this.formPageConfig.isEditMode)
      this.baseUpdateApi({
        expireDate: this.model.expireDate,
        id: this.formPageConfig.editId,
        keyword: this.model.keyword,
        useType: this.model.useType,
      });
    else this.baseCreateApi(this.model);
  }

  onSubmit() {
    try {
      this.model.expireDate = DateTimeService.toUTC(this.model.expireDate);
      super.onSubmit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
}
